import React from "react"; 
import "./style.css"; 


const Header = () => {
    return (
        <header className="header">
        </header>
    )
}

export default Header;